"use strict";

import angular from "angular";

import template from "./help-item-simple-topics-icon.component.html";
import "./themes/help-item-simple-topics-icon.component.scss";
import "./themes/help-item-simple-topics-icon-dark.component.scss";

class HelpItemSimpleTopicsIconComponent {
    constructor() {}

    $onInit() {}

    $onDestroy() {}

    $onChanges(changes) {}
}

HelpItemSimpleTopicsIconComponent.$inject = [];

const name = "helpItemSimpleTopicsIconComponent";
const def = {
    bindings: {
        content: "<"
    },
    controller: HelpItemSimpleTopicsIconComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
